import user_vector from '../../assets/img/user-vector.svg'

function InfoUsuario () {
    return(
        <div className="bg-red-c3 font-poppins font-normal text-white text-base rounded py-2 px-4 mr-4 lg:mr-0">
            <p className="info-usuario inline-block text-center align-middle leading-none">
                <img src={user_vector} alt="Ícone de usuário" className="object-contain max-w-full w-4 inline-block mr-2 align-middle" />
                {localStorage.getItem('usuariologado')} ({localStorage.getItem('idfilialusuario')-10000 +'-'+ localStorage.getItem('nomefilialusuario')})
            </p>
        </div>
    )
}

export default InfoUsuario